export const drawerWidth = '500px';
